class Permission {
  id = null;

  name;

  description;

  appId;

  appName;

  constructor(store, id) {
    this.store = store;
    this.id = id;
  }

  updateFromJson(json) {
    this.name = json.name;
    this.description = json.description;
    this.appId = json.appId;
    this.appName = json.appName;
  }
}

export default Permission;
